export default "__VITE_ASSET__BG8ZpnkR__"